export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./RichText.vue?vue&type=template&id=4995ca0a&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/RichText.vue?vue&type=template&id=4995ca0a&scoped=true&
// module id = 136
// module chunks = 0